import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import React from "react";
import Button from "../UI/ActionButton";
import IconComponent from "../Icons";

const ExportarExcel = ({ nomeArquivo = "dados", headers = [], rows = [] }) => {
  const handleExportar = () => {
    // Cria uma nova planilha
    const wsData = [headers, ...rows]; // Junta headers com os dados
    const ws = XLSX.utils.aoa_to_sheet(wsData);
    const wb = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(wb, ws, "Planilha1");

    // Gera o arquivo Excel
    const excelBuffer = XLSX.write(wb, {
      bookType: "xlsx",
      type: "array",
    });

    // Salva o arquivo

    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Gera a data e hora atual no formato desejado
    const agora = new Date();
    const pad = (num) => String(num).padStart(2, "0");
    const dataHora =
      `${pad(agora.getDate())}-${pad(agora.getMonth() + 1)}-${agora.getFullYear()}_` +
      `${pad(agora.getHours())}-${pad(agora.getMinutes())}`;

    const nomeFinal = `${nomeArquivo}_${dataHora}.xlsx`;

    saveAs(blob, `${nomeFinal}`);
  };

  return (
    <Button variant="success" type="button" onClick={handleExportar} className="w-100">
        <IconComponent icon="AiOutlineDownload" /> <span>Exportar Excel</span>
    </Button>
  );
};

export default ExportarExcel;
